import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import pathToIllustration from './assets/illustration.svg'

export const classes = {
  root: css`
    display: flex;
    flex-direction: column;
    height: 100vh;
  `,
  item: css`
    padding: ${spacing(2)};
  `,
  illustration: css`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  illustrationImage: css`
    width: ${spacing(33)};
    height: ${spacing(34)};
    background: url(${pathToIllustration}) no-repeat;
  `,
  illustrationText: css`
    text-align: center;
    white-space: pre-line;
  `,
}
